<template>
  <div>
    <SearchBar ref="SearchBar" :checkList="checkList" />
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="750"
    >
      <el-table-column label="区域" align="center" prop="areaName">
      </el-table-column>
      <el-table-column label="登录类型" align="center" prop="loginType">
        <template slot-scope="scope">
          {{ loginTypeEnum[scope.row.loginType] }}
        </template>
      </el-table-column>
      <el-table-column label="用户类型" align="center" prop="userType">
        <template slot-scope="scope">
          {{ scope.row.userType ? userTypeEnum[scope.row.userType] : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" align="center" prop="userId">
      </el-table-column>
      <el-table-column label="微信昵称" align="center" prop="nickName">
        <template> -- </template>
      </el-table-column>
      <el-table-column label="姓名" align="center" prop="nickName">
        <template slot-scope="scope">
          {{ scope.row.nickName ? handledecrypt(scope.row.nickName) : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="openID" align="center" prop="opendId">
        <template slot-scope="scope">
          {{ scope.row.opendId || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="邀请人" align="center" prop="inviteName">
        <template slot-scope="scope">
          {{
            scope.row.inviteName ? handledecrypt(scope.row.inviteName) : '--'
          }}
        </template>
      </el-table-column>

      <el-table-column label="设备ID" align="center" prop="deviceId">
        <template slot-scope="scope">
          {{ scope.row.deviceId || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="手机号"
        align="center"
        prop="mobile"
      >
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.mobile, scope.row.isShowAllPhone) }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="首次登录时间"
        align="center"
        prop="createTime"
      >
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="最后登录时间"
        align="center"
        prop="lastLoginTime"
      >
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="登录次数统计"
        align="center"
        prop="loginCount"
      >
      </el-table-column>

      <!-- <el-table-column
        class-name="status-col"
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="toLookAwait(scope.row)"
            v-if="roleList[path].includes('To_be_issued')"
            >查看日志详情</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <Detail ref="Detail" />
  </div>
</template>

<script>
import { getLoginLogApi } from '@/api/report.js';
import SearchBar from './components/searchBar'; // 搜索框
import Detail from './components/detail';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    SearchBar,
    Pagination,
    Detail,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      pageSize: 0,
      pageIndex: 0,
      path: '',
      checkList: [],
      loginTypeEnum: {
        0: '微信小程序',
        1: 'APP', // APP iOS
        2: 'APP', // APP 安卓
      },
      userTypeEnum: {
        1: '租售平台用户',
        2: '物业推荐用户',
        3: '酒店宴会推荐用户',
      },
    };
  },
  mounted() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // console.log('处理解密', str);
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    async fetchData(obj = {}) {
      try {
        let searchObj = this.$refs.SearchBar.getParams();
        this.listLoading = true;
        // const areaId = localStorage.getItem('areaId')
        //   ? JSON.parse(localStorage.getItem('areaId')).areaId
        //   : '';
        let res = await getLoginLogApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          // areaId,
          ...obj,
          ...searchObj,
        });
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.listLoading = false;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;

        this.$refs.Pagination.totalCount = Number(totalCount);
      } catch (e) {
        window.console.log(e);
      }
    },

    toLookAwait(row) {
      this.$refs.Detail.form = row;
      this.$refs.Detail.dialogFormVisible = true;
    },

    toLookYet(row) {
      if (row.userBonus === null) {
        return this.$message.error('无此数据！');
      }
      let bonusId = row.userBonus.bonusId;
      this.$router.push(`lookYet?id=${bonusId}`);
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
